<template>
    <div class="tag-div theme" :id="appearanceID">
        <div v-for="item in tagDatas" :key="item.ID" class="item-div" :id="item.ID"
            :style="{ backgroundColor: item.backgroundColor }">
            <div class="item-com-div" @click="nameClick(item)">{{ item.name }}</div>
            <div class="item-icon-div" v-html="item.icon" @click="iconClick(item)" v-show="isDisplayOperation"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TagStandard',
    props: {
        /**标签数据 */
        tagData: {
            type: Array,
            default: () => ([
                { 'name': '标签一' },
                { 'name': '标签二' },
                { 'name': '标签三' }
            ]),
            validator: (value) => {
                for (let item of value) {
                    if (!(Object.hasOwn(item, 'name'))) {
                        return false;
                    }
                }
                return true;
            }
        },
        /**自定义图标 */
        customIcon: {
            type: String,
            default: () => ``
        },
        /**是否显示操作图标 */
        isDisplayOperation: {
            type: Boolean,
            default: true
        },
        /**标签图标模式
         * remove: 删除图标，peg: 固定图标，custom: 自定义图标，blank: 空白图标
         */
        iconMode: {
            type: String,
            default: 'remove',
            validator: (value) => {
                return ['remove', 'peg', 'custom', 'blank'].includes(value);
            }
        },
        /**标签数据模式[模式, 是否重置] 
         * cover: 覆盖模式，append: 追加模式
        */
        dataMode: {
            type: Array,
            default: () => ['cover', false],
            validator: (value) => {
                return ['cover', 'append'].includes(value[0]);
            }
        },
        /**标签数量上限，0表示不限制 */
        upperLimit: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            svgString: {
                'remove': `<svg t="1782537488683" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1683" width="20" height="20"><path d="M219.8016 219.8016a51.2 51.2 0 0 1 72.3968 0L512 439.6032l219.8016-219.8016a51.2 51.2 0 1 1 72.3968 72.3968L584.3968 512l219.8016 219.8016a51.2 51.2 0 0 1-72.3968 72.3968L512 584.3968l-219.8016 219.8016a51.2 51.2 0 0 1-72.3968-72.3968L439.6032 512 219.8016 292.1984a51.2 51.2 0 0 1 0-72.3968z" fill="rgba(0,0,0,1)" p-id="1684"></path></svg>`,
                'peg': `<svg t="1782537613113" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2684" width="20" height="20"><path d="M97.7 938.9c-2.8 0-5.6-1.1-7.7-3.2-3.9-3.9-4.3-10.2-0.8-14.5L377 564.3c1.9-2.4 4.8-3.9 7.9-4 3.1-0.2 6.1 1 8.3 3.2l69.1 69.1c2.2 2.2 3.3 5.2 3.2 8.3-0.2 3.1-1.6 5.9-4 7.9l-357 287.7c-2 1.6-4.4 2.4-6.8 2.4z m288.7-351.5L169.8 856l268.6-216.6-52-52zM853.6 444.4c-17.4 0-33.7-6.8-46-19.1L600.4 218.1c-25.4-25.4-25.4-66.7 0-92.1 25.4-25.4 66.7-25.4 92.1 0l207.2 207.2c25.4 25.4 25.4 66.7 0 92.1-12.3 12.3-28.7 19.1-46.1 19.1z m-207.2-294c-5.6 0-11.1 2.1-15.4 6.3-8.5 8.5-8.5 22.2 0 30.7l207.2 207.2c8.2 8.2 22.5 8.2 30.7 0 8.5-8.5 8.5-22.2 0-30.7L661.8 156.7c-4.2-4.2-9.8-6.3-15.4-6.3z" p-id="2685"></path><path d="M604.2 811.6c-5.6 0-11.1-2.1-15.3-6.4L220.5 436.8c-8.5-8.5-8.5-22.2 0-30.7 24.6-24.6 57.3-38.1 92.1-38.1s67.5 13.5 92.1 38.1L619.6 621c50.8 50.8 50.8 133.4 0 184.2-4.3 4.3-9.8 6.4-15.4 6.4zM268.5 423.4l333.8 333.8c7.8-13.2 12-28.4 12-44.1 0-23.2-9-45-25.4-61.4L374 436.8c-16.4-16.4-38.2-25.4-61.4-25.4-15.8 0-30.9 4.2-44.1 12z" p-id="2686"></path><path d="M611.9 665.8c-5.7 0-11.3-2.3-15.3-6.4L366.3 429.2c-4.3-4.3-6.6-10.3-6.3-16.5 0.3-6.1 3.2-11.8 8-15.7l245.6-199.5c8.6-7 21.2-6.4 29 1.5l184.2 184.2c7.9 7.9 8.5 20.4 1.5 29L628.8 657.7c-3.9 4.8-9.6 7.7-15.7 8-0.4 0.1-0.8 0.1-1.2 0.1zM414 415.5l196.2 196.2 172-211.7-156.4-156.5-211.8 172z" p-id="2687"></path></svg>`
            },
            tagDatas: []
        }
    },
    watch: {
        tagData: {
            handler(newVal) {
                const incoming = Array.isArray(newVal) ? JSON.parse(JSON.stringify(newVal)) : [];
                const enriched = incoming.map(item => {
                    const copy = Object.assign({}, item);
                    copy.ID = this.generateGUID();
                    copy.backgroundColor = copy.backgroundColor || this.randomRGBAColor();
                    if (this.iconMode === 'remove') {
                        copy.icon = this.svgString.remove;
                    } else if (this.iconMode === 'peg') {
                        copy.icon = this.svgString.peg;
                    } else if (this.iconMode === 'custom') {
                        copy.icon = this.customIcon;
                    } else {
                        copy.icon = '';
                    }
                    return copy;
                });

                if (this.dataMode[0] === 'cover') {
                    this.tagDatas = enriched;
                } else if (this.dataMode[0] === 'append') {
                    if (this.dataMode[1]) {
                        this.tagDatas = enriched;
                    } else {
                        this.tagDatas = [...this.tagDatas, ...enriched];
                    }
                }
                this.tagDatas = this.tagDatas.map((it, idx) => ({ ...it, order: idx }));
                if (this.upperLimit > 0 && this.tagDatas.length > this.upperLimit) {
                    this.tagDatas = this.tagDatas.slice(this.tagDatas.length - this.upperLimit, this.tagDatas.length);
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        iconClick(data) {
            console.log('点击图标');
            data['iconMode'] = this.iconMode;
            this.$emit('iconClick', data);
        },
        nameClick(data){
            console.log('点击文本');
            this.$emit('nameClick', data);
        },
        generateGUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        randomRGBAColor() {
            const r = Math.floor(Math.random() * 256);
            const g = Math.floor(Math.random() * 256);
            const b = Math.floor(Math.random() * 256);
            const a = 0.3;
            return `rgba(${r}, ${g}, ${b}, ${a})`;
        },
        setMaxWidth() {
            let ap_div = document.getElementById(this.appearanceID);
            if (ap_div && ap_div.parentElement) {
                let parentWidth = ap_div.parentElement.offsetWidth;
                let currentWidth = parseFloat(getComputedStyle(ap_div).width);
                if (Math.abs(parentWidth - currentWidth) > 5) {
                    ap_div.style.setProperty('--ap-w', parentWidth + 'px');
                }
            }
        }
    },
    mounted() {
        // 获取当前控件的根 DOM 元素，并找到它的父元素（包裹这个控件的 div）
        const parentEl = this.$el.parentElement;
        if (!parentEl) return;
        // 实例化 ResizeObserver，当父元素尺寸变化时调用 setMaxHeight
        this.resizeObserver = new ResizeObserver(() => {
            this.setMaxWidth();
        });
        // 开始监听父元素
        this.resizeObserver.observe(parentEl);
        // 初始化时也手动调用一次，确保一进来宽度就是对的
        this.setMaxWidth();
    },
    computed: {
        appearanceID() {
            return this.generateGUID();
        }
    },
    beforeUnmount() {
        // 组件销毁前，断开监听，防止内存泄漏

    },
    created() {

    }
}
</script>

<style scoped>
.theme {
    --ap-w: 10px;
}

.tag-div {
    width: var(--ap-w);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    overflow-x: auto;
}

.item-div {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    margin: 5px 0;
    border-radius: 7px;
    cursor: pointer;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: center;
    position: relative;
    margin-right: 15px;
    flex-shrink: 0;
    white-space: nowrap;
    width: fit-content;
}

.item-com-div {
    font-size: 14px;
    color: #000000;
}

.item-icon-div {
    height: 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;

}
</style>
